export const DatenschutzContent = () => (
  <>
    <h1>Datenschutzerklärung für VIVA</h1>
    <p>
      Wir freuen uns darüber, dass du unsere Applikation Viva nutzen möchtest. Der Schutz Deiner personenbezogenen Daten
      ist uns sehr wichtig. Mit dieser Datenschutzerklärung möchten wir Dich darüber informieren, welche
      personenbezogenen Daten bei der Nutzung der Webanwendung von Dir erhoben und verarbeitet werden.
    </p>

    <h2>I. Wer sind wir und wie kannst du uns erreichen?</h2>
    <p>Wir, die</p>
    <p>
      Haufe Akademie GmbH & Co. KG
      <br />
      Ein Unternehmen der Haufe Group
      <br />
      Munzinger Straße 9<br />
      79111 Freiburg
      <br />
      E-Mail: <a href="mailto:service@haufe.de">service@haufe.de</a>.
    </p>
    <p>
      sind als Verantwortlicher im Sinne der EU-Datenschutzgrundverordnung (im Folgenden DSGVO genannt) dafür zuständig,
      deine personenbezogenen Daten zu schützen. Bei Fragen zur Datenverarbeitung, zu Deinen Rechten oder zur
      Datenschutzerklärung steht Dir auch unser Datenschutzbeauftragter Raik Mickler gerne zur Seite. Diesen erreichst
      du unter:
    </p>
    <p>
      <a href="mailto:dsb@haufe-lexware.com">dsb@haufe-lexware.com</a>.
    </p>

    <h2>II. Informationen zu Viva</h2>

    <h3>A. Was ist der Zweck von VIVA Webanwendung?</h3>
    <p>
      Viva dient allgemein innerhalb der Haufe Akademie der Planung und Durchführung von Veranstaltungen mit Kunden- und
      Expertenbezug.
    </p>

    <h3>B. Welche Rechtsgrundlage liegt für die Verarbeitung Deiner Daten vor?</h3>
    <p>Die Rechtsgrundlage stellt die Vertragserfüllung im Sinne des Art. 6 Abs. 1 lit. b. DSGVO dar.</p>

    <h3>C. An wen geben wir Deine Daten weiter?</h3>
    <h4>Übermittlung der Daten an Dritte:</h4>
    <p>
      Eine Weitergabe Deiner personenbezogenen Daten an Dritte erfolgt grundsätzlich nur, sofern dies zur Erbringung der
      Leistungserfüllung gegenüber unseren Kunden und Experten notwendig ist.
    </p>
    <h4>Auftragsverarbeitung:</h4>
    <p>Rechenzentrum/Hoster der Applikation ist Amazon Web Services EMEA SARL und Amazon Web Services Inc.</p>
    <p>
      Technische und organisatorische Maßnahmen der AWS sind einsehbar in{' '}
      <a
        href="https://d1.awsstatic.com/whitepapers/compliance/AWS_Risk_and_Compliance_Whitepaper.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        AWS&apos; Risk and Compliance Whitepaper
      </a>
      , dem{' '}
      <a
        href="https://d1.awsstatic.com/whitepapers/Security/AWS_Security_Whitepaper.pdf"
        target="_blank"
        rel="noopener noreferrer"
      >
        AWS Security Whitepaper
      </a>
      , dem öffentlich zugänglichen{' '}
      <a href="https://d1.awsstatic.com/whitepapers/compliance/AWS_SOC3.pdf" target="_blank" rel="noopener noreferrer">
        SOC 3 Bericht
      </a>{' '}
      und öffentlich zugänglichen{' '}
      <a href="https://aws.amazon.com/de/compliance/data-center/controls/" target="_blank" rel="noopener noreferrer">
        TOMs der Rechenzentren
      </a>
      .
    </p>

    <h2>III. Welche personenbezogenen Daten werden bei der Nutzung von VIVA verarbeitet und gespeichert?</h2>
    <p>
      Im Folgenden informieren wir Dich darüber, welche Daten beim Login in das VIVA Frontend erhoben werden, zu welchen
      Zwecken diese verarbeitet werden, auf welcher Rechtsgrundlage die Datenverarbeitung erfolgt, welche Möglichkeiten
      du hast, um die Erhebung und Verarbeitung der Daten selbst zu steuern und wann die Daten gelöscht werden.
    </p>

    <h3>A. Bei der Registrierung/LogIn in die VIVA Webanwendung</h3>
    <p>Zum LogIn nutzen wir das Azure AD von Microsoft im SSO Verbund</p>

    <h3>B. Welche Daten werden bei der Nutzung von Viva verarbeitet?</h3>
    <p>
      Wenn du die App nutzt, werden erforderliche Daten wie beispielsweise Deine IP-Adresse und weitere technische
      Merkmale beispielsweise zu deinem Browser, Betriebssystem etc. übertragen.
    </p>
    <p>Folgende personenbezogene Daten werden verarbeitet</p>
    <ul>
      <li>IP-Adresse</li>
      <li>Name, Vorname</li>
      <li>Login-Id (AD-Kennung mit Nachname und erstem Buchstaben des Vornamens)</li>
      <li>Email-Adresse</li>
    </ul>

    <h3>C. Cookies und Tracking</h3>
    <p>
      Für bestimmte Angebote setzen wir Cookies ein. Das sind kleine Textdateien, die auf Deinem Computer bzw. Deinem
      Endgerät gespeichert werden. So kann erkannt werden, wenn du die App vom gleichen Endgerät wiederholt besuchst
      oder nutzt.
    </p>
    <p>
      Session Cookies sind Cookies, die nur für die Dauer einer Internetsitzung auf Ihrem Endgerät gespeichert werden
      und für Transaktionen benötigt werden (z. B. für das Login). Sie enthalten lediglich eine Transaktions-ID.
    </p>

    <h3>D. Speicherdauer und Steuerungsoptionen</h3>
    <p>Wir löschen Deine personenbezogenen Daten, sobald sie für die jeweiligen Zwecke nicht mehr erforderlich sind.</p>

    <h2>IV. Welche Rechte hast du und wie kannst du diese wahrnehmen?</h2>

    <h3>A. Widerruf der Einwilligung</h3>
    <p>
      Du kannst ggf. erteilte Einwilligungen in die Verarbeitung deiner personenbezogenen Daten jederzeit mit Wirkung
      für die Zukunft widerrufen. Bitte beachte, dass der Widerruf keine Auswirkungen auf die Rechtmäßigkeit der
      bisherigen Datenverarbeitung hat und dass er sich nicht auf solche Datenverarbeitungen erstreckt, für die ein
      gesetzlicher Erlaubnisgrund vorliegt und die daher auch ohne Deine Einwilligung verarbeitet werden dürfen.
    </p>

    <h3>B. Weitere Betroffenenrechte</h3>
    <p>
      Darüber hinaus stehen Dir nach den Artikeln 15 bis 21 und 77 der EU-Datenschutzgrundverordnung (DSGVO) bei
      Vorliegen der gesetzlichen Voraussetzungen folgende Betroffenenrechte zu:
    </p>

    <h4>1. Auskunft:</h4>
    <p>
      Du kannst jederzeit verlangen, dass wir Dir Auskunft darüber erteilen, welche personenbezogenen Daten von Dir wie
      verarbeiten und eine Kopie der von Dir gespeicherten personenbezogenen Daten zur Verfügung stellen, Art. 15 DSGVO.
    </p>

    <h4>2. Berichtigung:</h4>
    <p>
      Du kannst die Berichtigung unrichtiger personenbezogener Daten sowie Vervollständigung unvollständiger
      personenbezogener Daten verlangen, Art. 16 DSGVO.
    </p>

    <h4>3. Löschung:</h4>
    <p>
      Du kannst die Löschung (Art. 17 DSGVO) Deiner Daten verlangen. Zur Löschung Deiner personenbezogenen Daten: Bitte
      beachte, von der Löschung ausgenommen sind Daten, die wir zur Durchführung und Abwicklung von Verträgen und zur
      Geltendmachung, Ausübung und Verteidigung von Rechtsansprüchen benötigen sowie Daten, für die gesetzliche,
      aufsichtsrechtliche oder vertragliche Aufbewahrungspflichten bestehen, Art. 17 DSGVO.
    </p>

    <h4>4. Einschränkung der Verarbeitung:</h4>
    <p>
      Du kannst unter bestimmten Umständen die Einschränkung der Verarbeitung verlangen, z.B. wenn du der Ansicht bist,
      dass Deine Daten unrichtig sind, wenn die Verarbeitung rechtswidrig ist oder du Widerspruch gegen die
      Datenverarbeitung eingelegt hast. Dies führt dazu, dass Deine Daten ohne Deine Einwilligung nur sehr beschränkt
      verarbeitet werden dürfen, z.B. zur Geltendmachung, Ausübung und Verteidigung von Rechtsansprüchen oder zum Schutz
      der Rechte anderer natürlicher und juristischer Personen, Art. 18 DSGVO.
    </p>

    <h4>5. Widerspruch gegen die Datenverarbeitung:</h4>
    <p>
      Du hast die Möglichkeit, jederzeit der Datenverarbeitung zu widersprechen. Zudem kannst du bei Vorliegen
      besonderer Gründe, jederzeit den Datenverarbeitungen widersprechen, die auf Grundlage eines berechtigten
      Interesses erfolgen, Art. 21 DSGVO.
    </p>

    <h4>6. Datenübertragbarkeit:</h4>
    <p>
      Du hast das Recht, die Daten, die du uns bereitgestellt und die wir von Dir verarbeiten, in einem gängigen,
      maschinenlesbaren Format zu erhalten und im Rahmen des technisch machbaren eine direkte Übermittlung dieser Daten
      an Dritte zu verlangen, Art. 20 DSGVO.
    </p>

    <h3>C. Kontaktwege</h3>
    <p>Du kannst deine Rechte über die folgenden Kontaktwege ausüben:</p>
    <p>
      Haufe Group
      <br />
      Herrn Raik Mickler
      <br />
      Datenschutzbeauftragter
      <br />
      Munzinger Straße 9<br />
      79111 Freiburg
      <br />
      E-Mail: <a href="mailto:dsb@haufe-lexware.com">dsb@haufe-lexware.com</a>
    </p>
    <p>
      Einwilligungen in die Datenverarbeitung durch Cookies und Trackingtechnologien kannst du durch entsprechende
      Einstellungen in deinem Browser bzw. des Cookie-Banners oder die im Abschnitt über Cookies und
      Targeting-Technologien im Detail beschriebenen Möglichkeiten widerrufen.
    </p>

    <h3>D. Recht auf Beschwerde bei einer Aufsichtsbehörde</h3>
    <p>
      Wenn du z.B. der Ansicht bist, dass unsere Datenverarbeitung rechtswidrig ist oder wir die oben beschriebenen
      Rechte nicht in dem notwendigen Umfang gewährt haben, hast du das Recht, bei der zuständigen
      Datenschutzaufsichtsbehörde Beschwerde einzulegen.
    </p>

    <p>Stand: März 2024</p>
  </>
);
